import { memo, useState } from "react"
import { format, isAfter, endOfDay, subDays, isBefore  } from "date-fns"
import  CurrencyInput, { formatValue } from 'react-currency-input-field';
import axiosService from "../../../utils/axios.service";
import { role } from '../../../enums/role.enum';
import { LoadingOutlined } from '@ant-design/icons';
import _ from 'lodash';
import { DatePicker } from "rsuite";
import Select from "react-select";
import { filterByStatus, accountSwipe } from "../../constant/GeneralData"

let optionScreen = [
    { value: 1, label: 'Màn hình 1' },
    { value: 2, label: 'Màn hình 2' },
]

const TransactionItem = ({order, customer, selectDataStore, screen, userAdmin, bankingType, socketRef, onChangeScreen, printInvoiceT, 
    handleDelete, setDepositMoney, getDataTransaction, setDataCustomer, isCustomerPage, notifications, requestDataTransactionCustomer, paymentProcessing}) => {
    const [isCopyText, setIsCopyText] = useState('')
    const [statusBankingType, setStatusBankingType] = useState(false)
    const [warningQr, setWarningQr] = useState(false)
    const [payAccount, setPayAccount] = useState(null)
    const [statusCheckQR, setStatusCheckQR] = useState(false);
    const [hiddenSubmit, setHiddenSubmit] = useState(false)
    const [currentOrder, setCurrentOrder] = useState(null)

    const [createdAt, setCreatedAt] = useState(new Date())
    const [payType, setPayType] = useState('Tiền mặt')
    const [paidAmount, setPaidAmount] = useState(0)
    const [storeId, setStoreId] = useState()
    const [disableStore, setDisableStore] = useState(false)

    const getDefaultStore = (idStore) => {
        if (!idStore) return null;

        let keyChoose = _.findIndex(selectDataStore, (o) => Number(o.value) == Number(idStore));
        return selectDataStore[keyChoose];
    }

    const getDefaultScreen = (option, screen) => {
        let keyChoose = _.findIndex(option, (o) => o.value == screen);
        return option[keyChoose];
    }

    const getDefaultPayment = (option, idStore) => {
        let keyChoose = _.findIndex(option, (o) => o.store == idStore);
        return option[keyChoose];
    }

    const copyText = (text) => {
        setIsCopyText('isCopy') 
        navigator.clipboard.writeText(text)
        setTimeout(() => {
            setIsCopyText('')
        }, 1000);
    }
    
    let onChangeCreatedAt = (event) => {
        setCreatedAt(event)
    }

    let onChangePaidAmount = (event, item) => {
        setDepositMoney(customer.deposit_money)
        let dataPrice = event.target.value.replaceAll(",", "");
        
        if (payType == 'Sử dụng thẻ tiền') {
            setDepositMoney(customer.deposit_money - dataPrice)
        }
        let moneyOwed =  item.old_owed
        if (moneyOwed < dataPrice) {
            dataPrice = moneyOwed
        }
        setPaidAmount(Number(dataPrice))
    }


    let onChangePayType = (event) => {
        setPayType(event.value)
        if (event.value == "Quẹt thẻ") {
            let select = getDefaultPayment(accountSwipe, storeId)
            if (select) setPayAccount(select.value)
        }

        let storeOrder = order.stores.id

        let findOrder = _.find(selectDataStore, (o) => o.value == order.stores.id);
        if (findOrder && findOrder.status === 2) storeOrder = 3
        
        if (event.value === "Chuyển khoản") {
            setStoreId(storeOrder)
            setDisableStore(true)
        } else {
            setStoreId(null)
            setDisableStore(false)
        }
    }

    const checkPayOs = async (data) => {
        if (paymentProcessing) return true
        setStatusCheckQR(true)
        let res = await axiosService("api/check-pay-os-debt", "POST", {id: data.id, store_id: localStorage.getItem("currentStore")})
        if (res.data.success == true) {
            if (res.data.data.mess && res.data.data.mess != "") {
                notifications({ type: 'warning', mess: res.data.data.mess});
                // socketRef.current?.emit("client-qr-code", {order: res.data.data.transaction.order, status: true, store_id: localStorage.getItem("currentStore")});
            } else {
                requestDataTransactionCustomer(res.data.data.transaction.order.id);
                // if (getDataTransaction) getDataTransaction(customer.id);
                notifications({ type: 'success', mess: 'Giao dịch đã được xác nhận' });
                // socketRef.current?.emit("client-qr-code", {order: null, status: false, store_id: localStorage.getItem("currentStore")});
            }
            setStatusCheckQR(false)
        } else {
            notifications({ type: 'warning', mess: res.data.message });
            setStatusCheckQR(false)
        }
    }

    const syncQrCode = async (order, banking_type = null) => {
        setWarningQr(false)
        setStatusBankingType(false)
        if (hiddenSubmit == true) return
        setHiddenSubmit(true)
        let payload = {
            price: paidAmount,
            id: order.id,
            store_id: storeId,
            pay_type: payType,
            transaction_at: createdAt,
            banking_type: banking_type ?? bankingType,
            screen: screen,
            store_qr: localStorage.getItem("currentStore")
        }

        let res = await axiosService("api/sync-qr-code-debt", "POST", payload);

        if (res.data.success) {
            requestDataTransactionCustomer(order.id);
            // getDataTransaction(customer.id);
            setPaidAmount(0)
            notifications({ type: 'success', mess: 'Cập nhật mã QR thành công' });
            // socketRef.current?.emit("client-qr-code", {order: order, status: true, store_id: localStorage.getItem("currentStore")});
            setHiddenSubmit(false)
        } else {
            notifications({ type: 'error', mess: res.data.message });
            setHiddenSubmit(false)
        }
    }

    const checkQrCode = async (order, banking_type = null) => {
        if (paidAmount == 0) return notifications({ type: 'warning', mess: 'Vui lòng điền số tiền lớn hơn 0' });
        if (!storeId) return notifications({ type: 'warning', mess: 'Vui lòng chọn chi nhánh' });

        if (!banking_type || banking_type == 2) return syncQrCode(order, 2)

        let res = await axiosService("api/check-qr-code", "POST", { id: order.id, store_qr: localStorage.getItem("currentStore"), screen: screen });
        if (res.data.success) {
            let countOrder = res.data.data
            if (countOrder === 0) {
                syncQrCode(order, banking_type)
            } else {
                setWarningQr(true)
                setStatusBankingType(false)
            }
        } else {
            notifications({ type: 'error', mess: res.data.message });
        }

    }

    const chooseTypeBanking = async (data) => {
        setCurrentOrder(data)
        if ([role.ADMIN].includes(userAdmin.role)) {
            setStatusBankingType(true)
        } else {
            if (role.LT == userAdmin.role) await checkQrCode(data, 1)
            if (role.SALE == userAdmin.role) await syncQrCode(data, 2)
        }
    }

    let addTransaction = (val) => {
        if (paidAmount == 0) return notifications({ type: 'warning', mess: 'Vui lòng điền số tiền lớn hơn 0' });
        if (!storeId) return notifications({ type: 'warning', mess: 'Vui lòng chọn chi nhánh' });

        let data = {
            "transaction_at": createdAt,
            "store_id": storeId,
            "order_id": val.id,
            "customer_id": customer.id,
            "pay_type": payType,
            "paid_amount": paidAmount,
            "order_code": val.order_code,
        }

        if (payType == 'Quẹt thẻ') data.pay_account_number = payAccount
        
        if (payType == 'Sử dụng thẻ tiền' && (Number(paidAmount) <= 0 || Number(paidAmount) > customer.deposit_money)) {
            notifications({type: 'error', mess: 'Số tiền trong tài khoản không đủ'}); 
            return
        }
        if (hiddenSubmit == true) return
        setHiddenSubmit(true)
        axiosService("api/transaction", "POST", data).then((res) => {
            const response = res.data;
            if (response.message == "success") {
                if (payType == 'Sử dụng thẻ tiền' && isCustomerPage && typeof isCustomerPage != 'undefined') {
                    setDataCustomer(res.data.data.deposit_money)
                    setDepositMoney(res.data.data.deposit_money)
                }
                requestDataTransactionCustomer(data.order_id);
                notifications({type: 'success', mess: 'Trả nợ thành công'});
                setPaidAmount(0)
                setHiddenSubmit(false)
            } else {
                setHiddenSubmit(false)
                notifications({type: 'error', mess: res.data.message });
            }
            // if (getDataTransaction) getDataTransaction(customer.id);
        })
        .catch((error) => console.log(error));
    }

    return (
        <div className="order-item-transaction">
            <div className="debt-order-list">
                <div className="debt-order-list-title">
                    <ul className="list-title hide-mobile">
                        <li className="text-bold text-primary font-18">Mã hóa đơn</li>
                        <li className="text-bold text-primary text-center">Thời gian</li>
                        <li className="text-bold text-primary text-center">Tổng tiền</li>
                        <li className="text-bold text-primary text-center">Đã trả</li>
                        <li className="text-bold text-primary text-center">Còn nợ</li>
                        <li className="text-bold text-primary text-center">Cơ sở</li>
                        <li className="text-bold text-primary text-right last-col">Người tạo đơn</li>
                    </ul>
                    <ul className="list-data">
                        <li className="mobile-table-haft">
                            <div className="title hide-desktop">Mã hóa đơn: </div>
                            <div className="value">
                                {order.order_code}
                            </div>
                        </li>
                        <li className="text-center mobile-table-haft">
                            <div className="title hide-desktop">Thời gian: </div>
                            <div className="value">{format(new Date(order.order_at), "dd-MM-yyyy HH:mm:ss")}</div>
                        </li>
                        <li className="text-center mobile-table-haft">
                            <div className="title hide-desktop">Tổng tiền: </div>
                            <div className="value">
                                <span className="cash-vnd text-right"> {order.total_price ? formatValue({
                                    value: String(order.total_price),
                                    groupSeparator: ',',
                                    decimalSeparator: '.',
                                }) : '0'}</span>
                            </div>
                        </li>
                        <li className="text-info text-center mobile-table-haft">
                            <div className="title hide-desktop">Đã trả: </div>
                            <div className="value">
                                <span className="cash-vnd text-info text-right"> {order.total_paid_amount ? formatValue({
                                    value: String(order.total_paid_amount),
                                    groupSeparator: ',',
                                    decimalSeparator: '.',
                                }) : '0'}</span>
                            </div>
                            
                        </li>
                        <li className="text-danger text-center mobile-table-haft">
                            <div className="title hide-desktop">Còn nợ: </div>
                            <div className="value">
                                <span className="cash-vnd text-danger text-right"> {order.money_owed ? formatValue({
                                    value: String(order.money_owed),
                                    groupSeparator: ',',
                                    decimalSeparator: '.',
                                }) : '0'}</span>
                            </div>
                        </li>
                        <li className="text-center mobile-table-haft">
                            <div className="title hide-desktop">Cơ sở: </div>
                        <div className="value">{order?.stores?.name_store ?? "CentMe"}</div>
                        </li>
                        <li className="text-right action-transacion mobile-table-haft last-col">
                            <div className="title hide-desktop">Người tạo đơn: </div>
                            <div className="value"> {order.User ? order.User.name : order.created_name}</div>
                        </li>
                    </ul>
                    <div className="debt-order-item-list">
                        {order.orderItem.map((item, itemKey) => ( 
                            <p key={itemKey} className="tag inline-tag">{item.product ? item.product.product_name : item.product_name}</p>
                        ))}
                    </div>
                    <ul className="debt-order-history"> 
                        <li className="item-transacion hide-mobile">
                            <div className="text-bold date-pay">Ngày thanh toán</div>
                            <div className="text-bold transaction-code">Mã giao dịch</div>
                            <div className="text-bold pay-method">Phương thức</div>
                            <div className="text-bold text-center payment-amount">Thanh toán</div>
                            <div className="text-bold text-center store-name">Cơ sở</div>
                            <div className="text-bold user-collecter">Thu ngân</div>
                            <div className="action-transaction"></div>
                        </li>
                        {order.transaction.map((item, itemKey) => (
                            <li key={itemKey} className="item-transacion">
                                <div className="date-pay mobile-table">
                                    <div className="title hide-desktop">Ngày thanh toán</div>
                                    <div className="value">
                                        {format(new Date(item.transaction_at), "HH:mm:ss")} <br />
                                        {format(new Date(item.transaction_at), "dd-MM-yyyy")}
                                    </div>
                                </div>
                                <div className="transaction-code mobile-table">
                                    <div className="title hide-desktop">Mã hoá đơn</div>
                                    <div className="value">{item.transaction_code}</div>
                                </div>
                                <div className="pay-method mobile-table">
                                    <div className="title hide-desktop">Phương thức</div>
                                    <div className="value">{item.pay_type}</div>
                                </div>
                                <div className="text-center payment-amount mobile-table">
                                    <div className="title hide-desktop">Thanh toán</div>
                                    <div className="value">
                                        <span className="cash-vnd text-right">{item.paid_amount ? formatValue({
                                            value: String(item.paid_amount),
                                            groupSeparator: ',',
                                            decimalSeparator: '.',
                                        }) : '0'} đ</span>
                                    </div>
                                    
                                </div>
                                
                                <div className="text-center store-name mobile-table">
                                    <div className="title hide-desktop">Cơ sở</div>
                                    <div className="value">{item?.store?.name_store ?? "CentMe"}</div>
                                </div>
                                <div className="user-collecter-value mobile-table">
                                    <div className="title hide-desktop">Thu ngân</div>
                                    <div className="value">{item.user.name}</div>

                                </div>
                                    <div className="text-right action">
                                        {item.payment_link_id ?
                                            item.status_pay_os == '1' ? 
                                                <button className="btn btn-xs bg-danger-400 pull-left mr-5 success-qr-bottom" ><i className="fas fa-check"></i></button>
                                            : 
                                                statusCheckQR ?
                                                    <button className="btn btn-xs bg-danger-400 pull-left mr-5 check-qr-bottom"><LoadingOutlined spin style={{position: "relative", top: "-3px"}}/></button>
                                                :
                                                    <button onClick={() => checkPayOs(item)} className="btn btn-xs bg-danger-400 pull-left mr-5 check-qr-bottom" ><i className="fas fa-qrcode"></i></button>
                                        : null}
                                        <button onClick={() => printInvoiceT(item, order)} className="btn btn-xs bg-danger-400 pull-left mr-5 print-botton" > <i className="fas fa-print"></i></button>
                                        {item.status == 2 ?<button onClick={() => handleDelete(item)} className="btn btn-xs bg-danger-400 pull-left remover-botton" ><i className="fa fa-trash"></i></button> : null}
                                    </div>
                                {item.uuid && item.banking_type == 1 ? 
                                    <div className="content-item">
                                        <div className="screen">
                                            Cơ sở hiển thị: {item.store_qr && <span>{getDefaultStore(item.store_qr)?.label} - {item.screen_qr}</span>}
                                        </div>
                                        <div className="screen">
                                            Cơ sở nhận tiền: {item.store_id && <span>{getDefaultStore(item.store_id)?.label}</span>}
                                        </div>
                                    </div> 
                                : null}
                                {item.pay_account_number ?
                                    <div className="pay-account-item-list"><span style={{marginRight: '30px'}}>Nội dung: {item.uuid}</span> STK: {item.pay_account_number}</div>
                                : null}
                                {item.uuid && item.banking_type == 2 ? 
                                    <div className="pay-account-item-list">
                                        Mã QR: 
                                        <a href={process.env.REACT_APP_QR_LINK + item.uuid} target="_blank" rel="noreferrer"> {process.env.REACT_APP_QR_LINK + item.uuid}</a>
                                        <button className={isCopyText} style={{marginLeft: '10px', lineHeight: "1.2", background: "#fff"}} onClick={() => copyText(process.env.REACT_APP_QR_LINK + item.uuid)}>Copy</button>
                                    </div> 
                                : null}
                            </li>
                        ))}
                        <li className="form-transaction">
                            <div className="input-transaction-date">
                                <DatePicker
                                    defaultValue={new Date()}
                                    oneTap
                                    format={"dd-MM-yyyy HH:mm"}
                                    className="custom-date-picker"
                                    onChange={onChangeCreatedAt}
                                    size="sm"
                                    readOnly={false}    
                                    disabledDate={date => {
                                        const today = endOfDay(new Date());
                                        const minDate = subDays(today, 4);
                                        return isAfter(date, today) || isBefore(date, minDate);
                                    }}
                                />
                            </div>
                            <div className="option-pay-method">
                                <Select components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }} 
                                    isSearchable={false}
                                    className="select"
                                    defaultValue={filterByStatus[0]}
                                    options={filterByStatus}
                                    onChange={(event) => onChangePayType(event)}
                                />
                            </div>
                            <div className="input-group cash-append-group customer-payment-amount">
                                <CurrencyInput
                                    className="text-right input-cash"
                                    placeholder="Nhập số tiền trả nợ"
                                    defaultValue={paidAmount}
                                    value={paidAmount}
                                    groupSeparator={','}
                                    decimalSeparator={'.'}
                                    onChange={(event) => onChangePaidAmount(event, order)}
                                />
                            </div>

                            <div className="button-action">
                                {order.old_owed > 0 ?
                                    payType == "Chuyển khoản" ? 
                                        <button onClick={!hiddenSubmit ? () => chooseTypeBanking(order) : () => {}} className={`btn btn-xs btn-primary ml-10 ng-binding btn-add-transaction ${hiddenSubmit ? "disable" : ""}`}>
                                            Tạo mã QR
                                        </button>
                                    :
                                        <button onClick={() => addTransaction(order)} className={`btn btn-xs btn-primary ml-10 ng-binding btn-add-transaction ${hiddenSubmit ? "disable" : ""}`}>
                                            Trả nợ
                                        </button>
                                : null}
                            </div>
                        </li>

                        {payType == "Chuyển khoản" ?
                            <li className="li-form-transaction">
                                {[role.LT, role.ADMIN].includes(userAdmin.role) ?
                                    <>
                                        <div className="pay-select-stores">Chọn màn hình</div>
                                        <div className="select-option-store">
                                            <Select components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }} 
                                                isSearchable={false}
                                                className="select"
                                                value={getDefaultScreen(optionScreen, screen)}
                                                options={optionScreen}
                                                onChange={onChangeScreen}
                                            />
                                        </div>
                                    </>
                                :null}
                            </li>
                        : null}

                        <li className="li-form-transaction">
                            <div className="pay-select-stores"><span className="">Tại chi nhánh</span></div>
                            <div className="select-option-store">
                                <Select components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }} 
                                    isDisabled={disableStore}
                                    isSearchable={false}
                                    className="select"
                                    value={getDefaultStore(storeId)}
                                    options={selectDataStore}
                                    onChange={(e) => {setStoreId(e.value)}}
                                />
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            {statusBankingType ?
                <div className="popup-cent payment">
                    <div className="content-popup fadeInDown">
                        <div className="head-popup">
                        <div className="title">Thông báo</div>
                        <div className="close" onClick={() => {setStatusBankingType(false)}}>×</div>
                        </div>
                        <div className="body-popup" style={{height: "auto"}}>
                        <div className="total-price payment-block" style={{marginBottom: "30px"}}>
                            <div className="title-body">Vui lòng chọn loại chuyển khoản mà bạn muốn: </div>
                        </div>
                        <div className="button-container" style={{justifyContent: 'center', display: 'flex'}}>     
                            <div className="button-cent style" style={{marginRight: "50px"}} onClick={() => {checkQrCode(currentOrder, 1)}}>
                            <span><i className="fas fa-store"></i></span>Tạo mã cho Cơ sở
                            </div>
                            <div className="button-cent style2" onClick={() => {syncQrCode(currentOrder, 2)}}>
                            <span><i className="fas fa-desktop"></i></span>Tạo mã cho Sale
                            </div>
                        </div>
                        </div>
                        <div className="bottom-popup">
                        <div className="button-container">
                            <button className="button-cent style3 save-and-book" onClick={() => {setStatusBankingType(false)}}>
                                <span><i className="fas fa-trash-alt"></i></span> Hủy
                            </button>
                        </div>
                        </div>
                    </div>
                    <div className="overlay" onClick={() => {setStatusBankingType(false)}}></div>
                </div>
            : null}
            {warningQr ?
                <div className="popup-cent payment mini-popup">
                    <div className="content-popup fadeInDown">
                        <div className="head-popup">
                            <div className="title">Cảnh báo</div>
                            <div className="close" onClick={() => {setWarningQr(false)}}>×</div>
                        </div>
                        <div className="body-popup" style={{height: "auto"}}>
                            <div className="total-price payment-block">
                                <div className="title-body">Đang có order hiển thị mã QR, bạn có muốn hiển thị đè order hiện tại lên không ?</div>
                            </div>
                        </div>
                        <div className="bottom-popup">
                            <div className="button-container">
                                <button className="button-cent save-and-book" onClick={() => {setWarningQr(false)}}>
                                    <span><i className="fas fa-trash-alt"></i></span> Hủy
                                </button>
                                <button className="button-cent" onClick={() => {syncQrCode(currentOrder, [role.LT,role.SALE].includes(userAdmin.role) ? bankingType : 1)} }>
                                    <span><i className="fas fa-save"></i></span> Đồng ý
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="overlay" onClick={() => {setWarningQr(false)}}></div>
                </div>
            : null}
        </div>
    )
}
export default memo(TransactionItem)